const wallSettings = {
    thicknessMeter: 0.1
}

export default wallSettings
